import L from "leaflet";

// Free basemap tiles from Esri ArcGIS Online — no API key required, no watermark.
export const DARK_TILES =
  "https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}";
export const LIGHT_TILES =
  "https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}";
// Plain-text credit only (no links, no Leaflet flag prefix).
export const TILE_ATTRIB = "© Esri · © OpenStreetMap contributors";

// Status → accent colour for vehicle pins.
export const STATUS_COLOR = {
  driver_on_way: "#0A6BB5",
  en_route: "#0A6BB5",
  assigned: "#6366F1",
  arrived: "#8B5CF6",
  on_board: "#14B8A6",
  confirmed: "#0EA5E9",
  completed: "#10B981",
  cancelled: "#F43F5E",
};

const carSvg = (color) =>
  `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="${color}" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2"/><circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/></svg>`;

// A round map pin containing a car glyph, tinted by status.
export const vehicleIcon = (status, stale) =>
  L.divIcon({
    className: "vaya-pin",
    html: `<span class="vaya-pin__dot" style="--pin:${
      STATUS_COLOR[status] || "#94A3B8"
    };opacity:${stale ? 0.55 : 1}">${carSvg(
      STATUS_COLOR[status] || "#94A3B8"
    )}</span>`,
    iconSize: [34, 34],
    iconAnchor: [17, 17],
    popupAnchor: [0, -18],
  });

// Simple coloured dot for origin / destination endpoints.
export const dotIcon = (color, label) =>
  L.divIcon({
    className: "vaya-endpoint",
    html: `<span class="vaya-endpoint__dot" style="--pin:${color}">${label || ""}</span>`,
    iconSize: [22, 22],
    iconAnchor: [11, 11],
  });
